import BaseModel from './BaseModel';
import * as AT from '../../components/container/attributes';
import Purchase from './Purchase';

export default class WorkOrderBill extends BaseModel {
  constructor({
    id,
    number,
    designation,
    memo = undefined,
    beginDate,
    endDate,
    billDate,
    closed,
    accepted,
    acceptanceDate,
    periodClosed,
    forwardedToCosts,
    netAmount,
    purchase,
    projectPartBillId,
    projectPartBill,
    sortOrder,
  }) {
    super(id, number, designation);
    this.memo = memo;
    this.beginDate = beginDate;
    this.endDate = endDate;
    this.billDate = billDate;
    this.closed = closed;
    this.accepted = accepted;
    this.acceptanceDate = acceptanceDate;
    this.periodClosed = periodClosed;
    this.forwardedToCosts = forwardedToCosts;
    this.netAmount = netAmount;
    this.purchase = purchase ? new Purchase(purchase) : null;
    this.projectPartBillId = projectPartBillId ?? projectPartBill?.id ?? null;
    this.projectPartBill = projectPartBill ?? null;
    this.sortOrder = sortOrder;
  }

  redirectToList(router) {
    router.push({
      name: 'purchaseDetail',
      params: {
        id: this.purchase?.id ?? 0,
      },
    });
  }

  static get config() {
    const config = BaseModel.config;
    config['addable'] = false;
    config['importable'] = false;
    config['duplicatable'] = false;
    config['browsable'] = false;
    return config;
  }

  get config() {
    return WorkOrderBill.config;
  }

  static get fkName() {
    return 'bill_id';
  }
  static get apiRoute() {
    return 'work_order_bill';
  }
  static get detailPageRoute() {
    return 'workOrderBilling';
  }
  static get listPageRoute() {
    return undefined;
  }
  get fkName() {
    return WorkOrderBill.fkName;
  }
  get apiRoute() {
    return WorkOrderBill.apiRoute;
  }
  get detailPageRoute() {
    return WorkOrderBill.detailPageRoute;
  }
  get listPageRoute() {
    return WorkOrderBill.listPageRoute;
  }

  static get joinAttrsKey() {
    return ['number', 'designation', 'beginDate', 'endDate', 'netAmount'];
  }

  static get entityListDisplayAttrs() {
    return this.getAttributes(
      [
        'number',
        'designation',
        'beginDate',
        'endDate',
        'netAmount',
        'accepted',
        'acceptanceDate',
        'closed',
      ],
      ['sortOrder', 'projectPartBillId', 'forwardedToCosts'],
    );
  }

  static get browserDisplayAttrs() {
    return this.getAttributes(
      ['number', 'designation', 'beginDate', 'endDate', 'netAmount'],
      ['billDate', 'purchase', 'projectPartBillId'],
    );
  }

  static get allAttributes() {
    return [
      this.NUMBER_ATTRIBUTE({}, {header: 'hit-app.common.number-short'}),
      this.DESIGNATION_ATTRIBUTE({}, { maxWidth: '5fr' }),
      new AT.StringAttribute({
        name: 'memo',
        tableProperties: {
          header: 'hit-base.common.memo',
        },
      }),
      new AT.DateAttribute({
        name: 'beginDate',
        column: 'begin_date',
        tableProperties: {
          header: 'hit-app.common.begin-date',
          minWidth: '4.90rem',
          maxWidth: '4.90rem',
        },
      }),
      new AT.DateAttribute({
        name: 'endDate',
        column: 'end_date',
        tableProperties: {
          header: 'hit-app.common.end-date',
          minWidth: '4.90rem',
          maxWidth: '4.90rem',
        },
      }),
      new AT.DateAttribute({
        name: 'billDate',
        column: 'bill_date',
        /*tableProperties: {
          header: 'hit-app.common.bill-date',
          maxWidth: '0.5fr',
        },*/
      }),
      new AT.BooleanAttribute({
        name: 'closed',
        tableProperties: {
          header: 'hit-app.common.closed',
          minWidth: '4.5rem',
          maxWidth: '0.7fr',
        },
      }),
      new AT.BooleanAttribute({
        name: 'accepted',
        tableProperties: {
          header: 'hit-app.common.accepted',
          maxWidth: '0.4fr',
        },
      }),
      new AT.DateTimeAttribute({
        name: 'acceptanceDate',
        column: 'acceptance_date',
        tableProperties: {
          // -short: two-line table header; full key kept for form labels / tooltip
          header: 'hit-app.common.acceptance-date-short',
          minWidth: '6.5rem',
          maxWidth: '6.5rem',
        },
      }),
      new AT.BooleanAttribute({
        name: 'periodClosed',
        column: 'period_closed',
        tableProperties: {
          header: 'hit-app.common.period-closed',
          maxWidth: '0.75fr',
        },
      }),
      new AT.BooleanAttribute({
        name: 'forwardedToCosts',
        column: 'forwarded_to_costs',
        /* tableProperties: {
           header: 'hit-app.common.forwarded-to-costs',
           maxWidth: '0.75fr',
         },*/
      }),
      new AT.DecimalAttribute({
        name: 'netAmount',
        decimalPrecision: 2,
        column: 'net_amount',
        tableProperties: {
          header: 'hit-app.common.amount',
          minWidth: '6rem',
          maxWidth: '1fr',
        },
      }),
      new AT.FkPurchaseAttribute({
        name: 'purchase',
        joinPath: ['purchase!fk_work_order_bill_purchase_id_purchase'],
        column: 'purchase_id',
        /*  tableProperties: {
            header: 'hit-app.common.purchase',
          }*/
      }),
      // Plain column only — avoid PostgREST embed (breaks list/detail if FK hint/name differs)
      new AT.StringAttribute({
        name: 'projectPartBillId',
        column: 'project_part_bill_id',
      }),
      new AT.IntegerAttribute({
        name: 'sortOrder',
        column: 'sort_order',
        readOnly: true,
      }),
    ];
  }
}
